import { useEffect } from "react";
import { listen, off } from "src/lib/socket";

function useSocketListener(key: string | null, callback: (res: any) => void) {
	const init = () => {
		if (key) {
			listen(key, callback);
		}
	};

	useEffect(() => {
		if (key) {
			init();
		}
		return () => {
			if (key) {
				off(key);
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [key]);
}

export default useSocketListener;
